import * as React from 'react';
import * as classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { DesktopNavigationSubmenu } from './DesktopNavigationSubmenu';
import { SVG } from '../../../../Utils/SVG';
import { NavigationRoot } from '../../../../../models';
const threeDotIcon = require('../../../../../icons/dotmenu.svg');
import './style.css';

export interface DesktopNavigationItemProps {
  item: NavigationRoot;
  desktopExpandedItem?: NavigationRoot;
  onExpandItem(item: NavigationRoot): void;
  onCollapseItem(item: NavigationRoot): void;
}

export interface DesktopNavigationItemState {
  /* empty */
}

export const COLLAPSE_DEBOUNCE_DELAY = 100;

export class DesktopNavigationItem extends React.Component<
  DesktopNavigationItemProps,
  DesktopNavigationItemState
> {
  private collapseTimeout?: number;

  render() {
    const { item, desktopExpandedItem, onExpandItem } = this.props;

    const classes = classNames({
      'desktop-navigation-item': true,
      showing: desktopExpandedItem === item
    });

    const linkClasses = classNames({
      'edge-of-play-link': true,
      'desktop-navigation-link': true,
      'overflow-link': item.isOverflowItem
    });

    const title = item.isOverflowItem ? '...' : item.name;
    const content = item.isOverflowItem ? (
      <SVG className="desktop-navigation-overflow-item" src={threeDotIcon} />
    ) : (
      title
    );

    // Prevent the overflow item ever being considered active
    const isActive = item.isOverflowItem ? () => false : undefined;

    return (
      <li
        className={classes}
        key={title}
        onMouseEnter={() => this.handleItemExpand(item)}
        onMouseLeave={() => this.queueItemCollapse(item)}
        onKeyUp={event => {
          if (event.key === 'Escape') {
            this.handleItemCollapse(item);
          }
        }}
        onFocus={() => onExpandItem(item)}
      >
        <NavLink
          isActive={isActive}
          className={linkClasses}
          to={item.url || `#`}
          onClick={item.onClick}
        >
          {content}
        </NavLink>
        <DesktopNavigationSubmenu item={item} />
      </li>
    );
  }

  private handleItemExpand = (item: NavigationRoot): void => {
    if (this.collapseTimeout) {
      clearTimeout(this.collapseTimeout);
      this.collapseTimeout = undefined;
    }

    const { onExpandItem } = this.props;
    onExpandItem(item);
  };

  private handleItemCollapse = (item: NavigationRoot): void => {
    if (this.collapseTimeout) {
      clearTimeout(this.collapseTimeout);
      this.collapseTimeout = undefined;
    }

    const { onCollapseItem } = this.props;
    onCollapseItem(item);
  };

  private queueItemCollapse = (item: NavigationRoot): void => {
    const { onCollapseItem } = this.props;

    this.collapseTimeout = window.setTimeout(() => {
      onCollapseItem(item);
    }, COLLAPSE_DEBOUNCE_DELAY);
  };
}

export default DesktopNavigationItem;



// WEBPACK FOOTER //
// ./src/app/components/App/Navigation/DesktopNavigation/DesktopNavigationItem/index.tsx